import { useLoading } from '@/contexts/LoadingContext';
import { CircularProgress, Modal } from '@mui/material';

interface ILoadingProps {
  /**
   * If it's to remove overlay from the screen
   */
  withoutOverlay?: boolean;
}

const Loading = ({ withoutOverlay }: ILoadingProps) => {
  const { isLoading } = useLoading();
  return withoutOverlay ? (
    <CircularProgress
      aria-label="Um meio circulo rodando na cor azul, representando o carregamento da página"
      sx={{
        position: 'absolute',
        left: 'calc(50% - 40px)',
        top: 'calc(50% - 40px)',
      }}
      size={80}
    />
  ) : (
    <Modal
      open={isLoading}
      sx={{
        display: 'grid',
        placeItems: 'center',
      }}
      disableAutoFocus
      disableScrollLock
    >
      <CircularProgress
        aria-label="Um circulo rodando na cor azul, representando o carregamento da página"
        size={80}
      />
    </Modal>
  );
};

export default Loading;
